import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
import { View } from '../ui/view';
export var lazy = function (fetch) {
    var component = null;
    return /** @class */ (function (_super) {
        tslib_1.__extends(LazyLoad, _super);
        function LazyLoad() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LazyLoad.prototype.onInit = function () {
            fetch()
                .then(function (loaded) { return (component = loaded.default); })
                .then(m.redraw)
                .catch(console.error);
        };
        LazyLoad.prototype.render = function () {
            var _a = this.attrs, children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return component && m(component, attrs, children);
        };
        return LazyLoad;
    }(View));
};
